import { render } from "./ModalSafety.vue?vue&type=template&id=51a39903&scoped=true"
import script from "./ModalSafety.vue?vue&type=script&lang=js"
export * from "./ModalSafety.vue?vue&type=script&lang=js"

import "./ModalSafety.vue?vue&type=style&index=0&id=51a39903&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a39903"]])

export default __exports__